<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import themeConfig from '@/../themeConfig.js'

import GetNotificacionesPedido from '@/apollo/queries/notificaciones/GetNotificacionesPedido.gql'

export default {
  data () {
    return {
      vueAppClasses: []
    }
  },
  mounted () {
    this.initPusher()

    this.initNotificaciones()
    
    // Verificar usuario autenticado
    this.$store.dispatch('setUserAuth')

    if(this.currentUser) {
      this.$store.dispatch('setUserData')
    }

    // Notificaciones
    this.getNotificacionesTienda()

    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  methods: {
    initPusher() {
      // Enable pusher logging - don't include this in production
      // Pusher.logToConsole = true;

      var pusher = new Pusher('2c034b9f443db7169ba8', {
        cluster: 'mt1'
      });

      var channel = pusher.subscribe('NotificacionPedido');

      let _this = this

      channel.bind('notificacion', function(data) {

        let dataAJson = JSON.parse(data)

        _this.enviarNotificacion(dataAJson)
      });
    },
    initNotificaciones() {
      // Let's check if the browser supports notifications
      if (!('Notification' in window)) {
        alert('Tu navegador no soporta notificaciones')

      } else {
        if(Notification.permission === 'denied' || Notification.permission === 'default') {

          Notification.requestPermission()
        }
        /* else {
          alert('Notificaciones anteriormente aceptadas')
        } */
      }
    },
    enviarNotificacion(data) {
      const opciones = {
        body: 'Nuevo pedido realizado',
        icon: './logo.png',
        image: './logo.png',
        vibrate: [200, 100, 200]
      }

      const n = new Notification('Nueva compra realizada', opciones)

      // Sonido
      let src = '/iphone-notificacion.mp3';
      let audio = new Audio(src);
      audio.play();

      n.onclick = () => {
        window.open(`https://administrador.kirasportswear.com/pedidos/${data.id}`);
      }

      this.getNotificacionesTienda()
    },
    getNotificacionesTienda() {
      this.$apollo.query({
        query: GetNotificacionesPedido,
        fetchPolicy: 'no-cache'
      })
      .then(response => {
        this.$store.commit('SET_NOTIFICACIONES', response.data.GetNotificacionesPedido)
      })
    },
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  async created () {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    ...mapState(['currentUser'])
  }
}

</script>

<style lang="scss">
.mw-100 {
  max-width: 100%;
}

.text-right {
  text-align: right;
}

.medium-text {
  font-size: 1.1em;
}

.vs-input {
  &--placeholder {
    color: #626262 !important;
  }

  &.isFocus {
    .vs-input--placeholder {
      color: #7367f0 !important;
    }
  }
}
</style>
